import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const location = useLocation();

  // You can replace this with your actual authentication logic.
  const isAuthenticated = localStorage.getItem('currentSubAccountId');

  if (!isAuthenticated) {
    // Encode the current path to be safely used in a URL query parameter
    const redirectURL = encodeURIComponent(location.pathname + location.search);
    
    // Redirect to the login page with the redirectURL as a query parameter
    return <Navigate to={`/login?redirectURL=${redirectURL}`} replace />;
  }

  return children;
};

export default PrivateRoute;